/* eslint-disable import/no-anonymous-default-export */
import { SupplyTab } from './SupplyTab';
import type { SupplyLight, SupplySummary } from '@wwf/sdk';

export default {
    list: SupplyTab,
    recordRepresentation: (record: SupplyLight | SupplySummary) =>
        record.name ?? `${record.id}`,
};
